import React from 'react';
import showroomDetail from '../img/Detail/showroom-detail.jpg';
import './Detail.css';
const ShowroomDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={showroomDetail} alt="Showroom Spatial Brand Experience" />
    </div>
  );
};

export default ShowroomDetail;
